// extracted by mini-css-extract-plugin
export var container = "value-section-module--container--mzmrq";
export var inner = "value-section-module--inner--0gKKd";
export var contentParagraph = "value-section-module--content-paragraph--IomyW";
export var imageWrapper = "value-section-module--image-wrapper--+J5Ps";
export var image = "value-section-module--image--1KCSi";
export var content = "value-section-module--content--Q9UN5";
export var imageContainer = "value-section-module--image-container--Wz0GU";